var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_10590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4038 9.92262C10.9138 9.43881 10.302 9.43881 9.81506 9.92262C9.44362 10.2909 9.07217 10.6593 8.70697 11.0338C8.60709 11.1368 8.52281 11.1587 8.40108 11.09C8.16074 10.9589 7.90479 10.8528 7.67381 10.7092C6.59694 10.0319 5.69486 9.16101 4.8958 8.18091C4.49938 7.69397 4.14667 7.17271 3.90008 6.58589C3.85014 6.46728 3.85951 6.38925 3.95627 6.29248C4.32771 5.93353 4.68979 5.56521 5.05499 5.19689C5.56377 4.68498 5.56377 4.08568 5.05186 3.57066C4.76158 3.27725 4.47129 2.99009 4.18101 2.69668C3.88135 2.39703 3.58483 2.09426 3.28205 1.79773C2.792 1.32016 2.18021 1.32016 1.69328 1.80085C1.31872 2.16917 0.959763 2.54685 0.578958 2.90893C0.226244 3.24292 0.0483268 3.65182 0.0108705 4.12938C-0.0484353 4.9066 0.141968 5.64012 0.410404 6.35491C0.959763 7.83444 1.79629 9.14853 2.81073 10.3534C4.18101 11.9827 5.8166 13.2718 7.72999 14.202C8.59149 14.6203 9.48419 14.9418 10.4549 14.9948C11.1229 15.0323 11.7035 14.8637 12.1686 14.3425C12.4869 13.9866 12.8459 13.662 13.183 13.3218C13.6824 12.8161 13.6855 12.2043 13.1892 11.7049C12.5962 11.1087 12 10.5157 11.4038 9.92262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8093 7.43515L11.9611 7.23851C11.7801 6.18037 11.2807 5.22211 10.5222 4.4605C9.71998 3.65831 8.70554 3.15265 7.58809 2.99658L7.42578 4.15461C8.2904 4.27634 9.07698 4.66651 9.69813 5.28766C10.2849 5.87447 10.6689 6.61736 10.8093 7.43515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6098 2.42842C11.2801 1.09872 9.59764 0.259073 7.74044 0L7.57812 1.15802C9.1825 1.38276 10.6371 2.11004 11.7857 3.25558C12.8751 4.34493 13.5899 5.72145 13.8489 7.23531L15.0007 7.03866C14.6979 5.28446 13.8708 3.69257 12.6098 2.42842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_10590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.da8b4821c01dfbe01aea88430e748ff1.svg";
export { ForwardRef as ReactComponent };